/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Status_504Inputs */

const vi_carrier_status_504 = /** @type {(inputs: Carrier_Status_504Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chuyển hoàn thành công`)
};

/**

* @param {Carrier_Status_504Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_status_504 = /** @type {((inputs?: Carrier_Status_504Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Status_504Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_status_504(inputs)
});